import React from 'react';
import {SetState} from "../../redux/reduxhelper";
import {DOMAIN_NAME, THEME_CSS} from "../../redux/action/type.action";
import {useDispatch} from "react-redux";
import Loading from "../../components/loading/Loading";
import {useDebounceEffect} from "../../hooks/useDebounceEffect";

const ThemeSelector = ({children}) => {
    const dispatch = useDispatch();
    // const domainName = document.location.hostname.split('.')[0];


    // const myData = GetState(DOMAIN_NAME, null);
    let themeName = null;
    const getVipInfo = async () => {
        try {
            //await sleep(3000)
            // let res = await getVipConfigApi(dName);
            // let resData = res?.data?.data;
            const {
                id,
                business_id,
                domain_name,
                name,
                // theme_name,
                logo,
                theme_color,
                background_color,
                color,
                enamad
            } = domain_obj ?? {};
            let data = {id,business_id,enamad, theme_name, domain_name, name, logo, theme_color, background_color, color};
            // console.log('try to set redux data', data);

            dispatch(SetState(DOMAIN_NAME, data));
            themeName = `${data?.theme_name}`;
            if (data?.theme_name !== undefined) {
                dispatch(SetState(THEME_CSS, themeName));
            }

        } catch (e) {
            // log error
            console.log('error on update state', null);
        }
    }

    useDebounceEffect(async () => {
        // const domainName = document.location.hostname.split('.')[0];
        await getVipInfo();
    }, 10, []);

    // const manifestDetails = {
    //     "theme_color": myData?.theme_color ?? "#6fb64c",
    //     "background_color": myData?.background_color ?? "#6fb64c",
    //     "color": myData?.color ?? "#ffffff",
    //     "display": "standalone",
    //     "short_name": myData?.name,
    //     "name": myData?.name,
    //     "icons": [
    //         {
    //             "src": myData?.logo,
    //             "sizes": "any"
    //         }
    //     ]
    // };

    // useDebounceEffect(async () => {
    //     if (myData != null) {
            // await reactManifest.update(manifestDetails, "#manifest-placeholder");
            // await document.querySelector('#theme-color').setAttribute('content', myData?.theme_color);
            // await document.querySelector('#fav-icon').setAttribute('href', myData?.logo);
    //     }
    // }, 20,[]);

    // if (myData === null) {
    //     setTimeout(()=>{
    //         document.location.reload();
    //     },1000)
    //     return <><Loading/></>
    // };

    return (
        <>
            <React.Suspense fallback={<><Loading/></>}/>
            {children}
        </>
    );
};

export default ThemeSelector;